const STAGGER_DELAY_MS = 50;

const ListFeatureCard = ({
  feature,
  isVisible,
  index,
  onClick,
  isSelected,
}) => {
  return (
    <div
      role="button"
      tabIndex={0}
      className={`
        group p-6 w-full bg-white rounded-2xl shadow-lg
        border-2
        transition-all duration-300 ease-out-expo active:scale-95
        hover:shadow-xl hover:shadow-sky-500/10 hover:-translate-y-1.5
        ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}
        ${
          isSelected
            ? "border-sky-400 shadow-lg shadow-sky-500/20"
            : "border-transparent"
        }
      `}
      style={{ transitionDelay: `${index * STAGGER_DELAY_MS}ms` }}
      onClick={() => onClick(feature)}
    >
      <div className="flex flex-col items-center text-center">
        <div
          className={`
            flex-shrink-0 w-16 h-16 mb-4 flex items-center justify-center rounded-full text-3xl
            transition-all duration-400 ease-out-expo group-hover:scale-110
            ${isSelected ? "bg-sky-500 text-white" : "bg-sky-100 text-sky-600"}
          `}
        >
          {feature.icon}
        </div>
        <h4 className="font-bold text-slate-800 text-lg leading-tight">
          {feature.title}
        </h4>
      </div>
    </div>
  );
};

export default ListFeatureCard;
